module.exports = __webpack_public_path__ + "img/extended.6bbd0492.png";